import { api } from '@/services/api';
import { useMutation } from '@tanstack/react-query';

interface Credentials {
  login: string;
  senha: string;
  baseURL: string
  filial: string;
}

export function useSignIn() {

  return useMutation({
    mutationKey: ['signin'],
    mutationFn: async (credentials: Credentials) => {
      return await api.post(`auth/v1/filial`, {login: credentials.login, senha: credentials?.senha, filial: credentials?.filial}, {
        headers: {
          'Authorization': 'Bearer ' + credentials?.baseURL
        }
      })},
  });
}
